import { render, staticRenderFns } from "./PsiActionDropDown.vue?vue&type=template&id=01f27fa2&scoped=true&"
import script from "./PsiActionDropDown.vue?vue&type=script&lang=js&"
export * from "./PsiActionDropDown.vue?vue&type=script&lang=js&"
import style0 from "./PsiActionDropDown.vue?vue&type=style&index=0&id=01f27fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f27fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VChip,VDivider,VIcon,VList,VListGroup,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VMenu})
